function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m44.131 32 18.195-18.195c2.2327-2.2327 2.2327-5.8527 0-8.0873l-4.0436-4.0436c-2.2327-2.2327-5.8527-2.2327-8.0873 0l-18.195 18.195-18.195-18.195c-2.2327-2.2327-5.8527-2.2327-8.0873 0l-4.0436 4.0436c-2.2327 2.2327-2.2327 5.8527 0 8.0873l18.195 18.195-18.195 18.195c-2.2327 2.2327-2.2327 5.8527 0 8.0873l4.0436 4.0436c2.2327 2.2327 5.8545 2.2327 8.0873 0l18.195-18.195 18.195 18.195c2.2327 2.2327 5.8545 2.2327 8.0873 0l4.0436-4.0436c2.2327-2.2327 2.2327-5.8527 0-8.0873z",
    fill: "currentColor",
    style: {
      strokeWidth: 0.18182
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6fd8e0fe.svg";
export { ForwardRef as ReactComponent };